<template>
  <v-container fluid>
    <div v-if="loading">
      <v-skeleton-loader type="list-item-avatar, list-item-three-line, actions" class="mb-3"></v-skeleton-loader>
      <v-skeleton-loader type="table"></v-skeleton-loader>
    </div>
    <div v-else>
      <v-row class="mt-0 mb-2" justify="space-between" no-gutters>
        <v-col cols="12" md="4">
          <v-card class="py-3 px-4 vcard_area">
            <v-row>
              <v-col cols="12" md="7">
                <div class="text-h1">Produtos</div>
                <div v-if="!$root.Permissions.revendor()" class="text text--thin mb-2 mt-2">Adicione um novo produto</div>
                <v-btn v-if="!$root.Permissions.revendor()" @click="openCloseDialog()" color="primary" class="mt-1"><v-icon class="mr-1">solar_power</v-icon>Novo produto</v-btn>
              </v-col>
              <v-col cols="12" md="5" v-if="!$root.Permissions.revendor()">
                <div class="icon_area" :class="$vuetify.theme.dark ? 'dark_area' : 'white_area'">
                  <v-icon>add</v-icon>
                </div>
              </v-col>
            </v-row>
          </v-card>
        </v-col>
        <v-col cols="12" md="4" class="text-md-right text-center" v-if="!$root.Permissions.revendor()">
          <v-btn @click="dialogImport = true" color="primary" class="mt-1"><v-icon class="mr-1">file_upload</v-icon>Importar produtos</v-btn>
        </v-col>
      </v-row>
      <v-data-table
        :headers="headers"
        :items="dados"
        disable-sort
        :server-items-length="total"
        :options.sync="options"
        loading-text="Carregando... Por favor aguarde"
        :loading="carregando"
        class="elevation-1 base_table"
        :footer-props="{
          itemsPerPageOptions: [1,5,10,15,20,25,50,100],
          showFirstLastPage: true,
          firstIcon: 'skip_previous',
          lastIcon: 'skip_next',
          prevIcon: 'chevron_left',
          nextIcon: 'chevron_right'
        }"
        :header-props="{
          sortIcon: 'north',
        }"
      >
        <template v-slot:top>
          <v-row no-gutters align="center">
            <v-row no-gutters align="center">
              <v-col class="py-2 px-2">
                <v-form @submit.prevent="applyFilter()">
                  <v-text-field
                    clearable
                    hide-details=""
                    clear-icon="close"
                    v-model="search"
                    outlined
                    label="Busca"
                    @click:clear="limparBusca()"
                  ></v-text-field>
                </v-form>
              </v-col>
              <v-col class="py-2 px-2" v-if="!$root.Permissions.distributor()">
                <v-autocomplete
                  :menu-props="{ offsetY: true}"
                  v-model="distribuidor"
                  :items="distribuidores"
                  hide-details=""
                  clearable
                  clear-icon="close"
                  label="Distribuidor"
                  append-icon="expand_more"
                  outlined
                  @change="applyFilter()"
                  @click:clear="applyFilter()"
                >
                </v-autocomplete>
              </v-col>
              <v-col class="py-2 px-2" v-if="!$root.Permissions.integrator()">
                <v-autocomplete
                  :menu-props="{ offsetY: true}"
                  v-model="integrador"
                  :items="integradores"
                  hide-details=""
                  clearable
                  clear-icon="close"
                  label="Integrador"
                  append-icon="expand_more"
                  outlined
                  @change="applyFilter()"
                  @click:clear="applyFilter()"
                >
                </v-autocomplete>
              </v-col>
              <v-col class="py-2 px-2">
                <v-autocomplete
                  :menu-props="{ offsetY: true}"
                  v-model="categoria"
                  :items="categorias"
                  hide-details=""
                  clearable
                  clear-icon="close"
                  label="Categoria"
                  append-icon="expand_more"
                  outlined
                  @change="applyFilter()"
                  @click:clear="applyFilter()"
                >
                </v-autocomplete>
              </v-col>
              <v-col class="py-2 px-2">
                <v-autocomplete
                  :menu-props="{ offsetY: true}"
                  v-model="marca"
                  :items="marcas"
                  hide-details=""
                  clearable
                  clear-icon="close"
                  label="Marca"
                  append-icon="expand_more"
                  outlined
                  @change="applyFilter()"
                  @click:clear="applyFilter()"
                >
                </v-autocomplete>
              </v-col>
              <v-col class="py-2 px-2">
                <v-autocomplete
                  :menu-props="{ offsetY: true}"
                  v-model="modelo"
                  :items="modelos"
                  hide-details=""
                  clearable
                  clear-icon="close"
                  label="Modelo"
                  append-icon="expand_more"
                  outlined
                  @change="applyFilter()"
                  @click:clear="applyFilter()"
                >
                </v-autocomplete>
              </v-col>
              <v-col class="py-2 px-2" v-if="!$root.Permissions.admin()">
                <v-switch
                  hide-details
                  class="mt-1 mb-2"
                  color="success"
                  v-model="show_base"
                  @change="applyFilter()"
                  label="Mostrar produtos base"
                ></v-switch>
              </v-col>
              <v-col md="1" class="py-2 px-2">
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn v-bind="attrs" v-on="on" color="primary" @click="limparFiltros()">
                      <v-icon class="mr-1">filter_alt_off</v-icon>
                      <span class="text subtitle-2 text-center">Limpar filtros</span>
                    </v-btn>
                  </template>
                  <span>Limpa os filtros e lista seus produtos cadastrados</span>
                </v-tooltip>
              </v-col>
              <v-col md="1" class="py-2 px-2">
                <v-menu
                  bottom
                  center
                  offset-y
                  max-height="400"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <div v-bind="attrs" v-on="on" class="text-right">
                      Exportar
                      <v-icon>arrow_drop_down</v-icon>
                    </div>
                  </template>
                  <v-list>
                    <v-list-item @click="exportXls()">
                      <v-list-item-icon class="mr-1">
                        <v-icon color="primary">receipt_long</v-icon>
                      </v-list-item-icon>
                      <v-list-item-title>Exportar para XLS</v-list-item-title>
                    </v-list-item>
                    <v-list-item @click="exportPdf()">
                      <v-list-item-icon class="mr-1">
                        <v-icon color="primary">picture_as_pdf</v-icon>
                      </v-list-item-icon>
                      <v-list-item-title>Exportar / Imprimir PDF</v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </v-col>
            </v-row>
          </v-row>
        </template>
        <template v-slot:item.pro_imagem="{ item }">
          <img v-if="item.pro_imagem" class="produto_imagem" :src="item.pro_imagem" alt="Imagem">
        </template>
        <template v-slot:item.pro_categoria="{ item }">
          <v-chip small label :color="retornaCategoria(item.pro_categoria).color" text-color="white">
            {{ retornaCategoria(item.pro_categoria).text }}
          </v-chip>
        </template>
        <template v-slot:item.actions="{ item }">
          <v-row no-gutters align="center" justify="center"
            v-if="$root.Permissions.admin() || $root.Permissions.distributor() && !item.fk_int_id_integrador || $root.Permissions.integrator() && item.fk_int_id_integrador"
          >
            <v-tooltip top v-if="!$root.Permissions.revendor()">
              <template v-slot:activator="{ on, attrs }">
                <v-icon v-bind="attrs" v-on="on" @click="buscaProduto(item)" color="primary" class="mr-2">
                  edit
                </v-icon>
              </template>
              <span>Editar</span>
            </v-tooltip>
            <v-tooltip top v-if="!$root.Permissions.revendor()">
              <template v-slot:activator="{ on, attrs }">
                <v-icon v-bind="attrs" v-on="on" @click="openDialogDelete(item)" color="primary" class="ml-2">
                  delete
                </v-icon>
              </template>
              <span>Excluir</span>
            </v-tooltip>
          </v-row>
        </template>
      </v-data-table>
    </div>
    <v-dialog v-model="dialogExcluir" max-width="400">
      <v-card class="ui-dialog-top">
        <v-row align="center" justify="space-between">
          <v-col cols="10">
            Excluir Produto
          </v-col>
          <v-col cols="2" class="text-right">
            <v-icon @click="cancelProdutoDelete()">close</v-icon>
          </v-col>
        </v-row>
      </v-card>
      <v-card class="ui-dialog-content">
        <div class="text-h3 mb-5">
          Tem certeza que deseja excluir Produto <b class="text-primary" v-if="produtoExcluir">{{produtoExcluir.pro_nome}}</b>?
        </div>
        <v-divider class="mb-3"></v-divider>
        <v-row
          align="center"
          justify="space-between"
          class="px-5 py-5"
        >
          <v-btn
            color="cancel"
            @click="cancelProdutoDelete()"
            :loading="salvando"
            :disabled="salvando"
          >
            Cancelar
          </v-btn>
          <v-btn
            color="success"
            :loading="salvando"
            :disabled="salvando"
            @click="removerProduto()"
          >
            Excluir
          </v-btn>
        </v-row>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="dialogImport"
      persistent
      max-width="850px"
    >
      <v-card class="ui-dialog-top">
        <v-row align="center" justify="space-between">
          <v-col cols="10">
            Importar produtos
          </v-col>
          <v-col cols="2" class="text-right">
            <v-icon @click="dialogImport = false">close</v-icon>
          </v-col>
        </v-row>
      </v-card>
      <v-card class="ui-dialog-content">
        <v-row align="center">
          <v-col cols="12" sm="7" md="7" lg="7" xl="7">
            <div class="text">
              Aqui você consegue cadastrar vários produtos de uma vez. <br>
              Para realizar este cadastro em lote, você vai precisar preencher uma planilha modelo do StartIn com os produtos que deseja cadastrar. Clique no botão abaixo para fazer o download da planilha modelo.
              <br>
              <a :href="`${API_URL_FILE}produtos.xlsx`" target="_blank">
                <v-btn color="primary" class="mt-2 mb-3">
                  <v-icon class="mr-1">import_export</v-icon>
                  Download planilha modelo
                </v-btn>
              </a>
            </div>
          </v-col>
          <v-col cols="12" sm="5" md="5" lg="5" xl="5">
            <v-form ref="formImportar">
              <div class="text text--thin mb-2">
                Selecione o arquivo em excel com os produtos
              </div>
              <v-file-input
                show-size
                clearable
                ref="file"
                v-model="produto_importar"
                prepend-icon="description"
                label="Arquivo*"
                clear-icon="close"
                truncate-length="50"
                :loading="salvando"
                :disabled="salvando"
                :rules="[rules.required, rules.size]"
                hint="Tamanho máximo permitido: 10MB"
                persistent-hint
                outlined
              ></v-file-input>
            </v-form>
          </v-col>
        </v-row>
        <v-divider></v-divider>
        <v-row no-gutters class="mt-4 mb-0" align="center" justify="space-between">
          <v-btn
            color="cancel"
            :loading="salvando"
            :disabled="salvando"
            @click="dialogImport = false"
          >
            Cancelar
          </v-btn>
          <v-btn
            color="primary"
            @click="importaProdutos()"
            :loading="salvando"
            :disabled="salvando"
          >
            Salvar
          </v-btn>
        </v-row>
      </v-card>
    </v-dialog>
    <produtos-form
      v-on:cancelar-close="openCloseDialog()"
      :abrir_dialog="dialogProduto"
      :produto_selecionado="produto"
      v-on:refresh="getProdutos">
    </produtos-form>
  </v-container>
</template>

<script>
import Api, { API_URL_FILE } from '@API'
import ProdutosForm from './ProdutosForm.vue'
export default {
  components: {
    ProdutosForm
  },
  data () {
    return {
      API_URL_FILE,
      loading: false,
      salvando: false,
      dialogExcluir: false,
      loadingModules: false,
      dialogImport: false,
      produto: {},
      produtoExcluir: null,
      produto_importar: [],
      search: '',
      modulos: [],
      distribuidores: [],
      distribuidor: null,
      integradores: [],
      integrador: null,
      optionsMoney: {
        locale: 'pt-BR',
        prefix: 'R$',
        suffix: '',
        length: 10,
        precision: 2
      },
      headers: [
        {
          text: 'ID',
          align: 'start',
          value: 'pro_id'
        },
        { text: 'Nome', value: 'pro_nome' },
        { text: 'Imagem', value: 'pro_imagem' },
        { text: 'Categoria', value: 'pro_categoria' },
        { text: 'Marca', value: 'marca' },
        { text: 'Modelo', value: 'modelo' },
        { text: 'Preço de custo', value: 'pro_preco_custo' },
        { text: 'Preço de venda', value: 'pro_preco_venda' },
        {
          text: 'Ações',
          value: 'actions',
          align: 'center',
          sortable: false,
          width: 110
        }
      ],
      dados: [],
      rules: {
        required: value => !!value || 'Obrigatório.',
        size: value => !value || value.size < 10000000 || 'Arquivo precisa ter menos que 10MB!'
      },
      carregando: false,
      options: {},
      total: 0,
      categoria: null,
      marca: null,
      marcas: [],
      loadingMarcas: false,
      modelo: null,
      modelos: [],
      loadingModelos: false,
      dialogProduto: false,
      categorias: [],
      loadingCategorias: false,
      show_base: false,
      dadosExport: [],
      headersExport: []
    }
  },
  computed: {
    abrir_dialog () {
      return this.openCloseDialog()
    }
  },
  watch: {
    options: {
      handler () {
        this.getProdutos()
      },
      deep: true
    }
  },
  methods: {
    async exportXls () {
      this.loadingXls = true
      Api.post('relatorios/exportar', {
        headers: this.someHeader(),
        busca: this.search,
        distribuidor: this.distribuidor && !this.integrador ? this.distribuidor : null,
        integrador: this.integrador ? this.integrador : null,
        categoria: this.categoria ? this.categoria : null,
        marca: this.marca ? this.marca : null,
        modelo: this.modelo ? this.modelo : null,
        produtos_base: this.show_base ? this.show_base : null,
        type: 'produtos'
      })
        .then(res => {
          this.downloadXls(res.data.url)
          this.removeXls(res.data.url)
          this.loadingXls = false
        })
        .catch(err => {
          console.log(err)
          this.$root.SnackControl.open(this, {
            text: 'Ops, ocorreu um erro ao fazer o download!',
            color: 'error'
          })
        })
    },
    async downloadXls (url) {
      const a = document.createElement('a')
      a.href = url
      a.download = url.split('/').pop()
      document.body.appendChild(a)
      a.click()
      document.body.removeChild(a)
    },
    removeXls (url) {
      let data = {
        url: url
      }
      Api.post('relatorios/remove-s3', data)
    },
    someHeader () {
      let cabecalhos = []
      this.headers.map(header => {
        if (header.text !== 'ID' && header.text !== 'Ações' && header.text !== 'Usuários' && header.text !== 'Imagem') cabecalhos.push(header)
      })
      return cabecalhos
    },
    ajustaDadosParaPDF () {
      this.dadosExport = JSON.parse(JSON.stringify(this.dados))
      this.dadosExport.map(item => {
        item.pro_categoria = this.retornaCategoria(item.pro_categoria).text
      })
    },
    async exportPdf () {
      let url = 'produtos?'
      if (this.search) url += `&busca=${this.search}`
      if (this.categoria) url += '&categoria=' + this.categoria
      if (this.marca) url += '&marca=' + this.marca
      if (this.modelo) url += `&modelo=${this.modelo}`
      if (this.distribuidor && !this.integrador) url += `&distribuidor=${this.distribuidor}`
      if (this.integrador) url += `&integrador=${this.integrador}`
      if (this.show_base) url += `&produtos_base=${this.show_base}`

      this.$root.Export.PDF(this, {
        titulo: 'Lista de produtos',
        tabela: {
          headers: this.headers,
          categorias: this.categorias,
          url
        }
      })
    },
    loadFunctions () {
      let filters = this.$route.query
      if (filters.busca) this.search = filters.busca
      if (filters.categoria) this.categoria = filters.categoria
      if (filters.marca) this.marca = filters.marca
      if (filters.modelo) this.modelo = filters.modelo
      if (filters.distribuidor) this.distribuidor = filters.distribuidor
      if (filters.integrador) this.integrador = filters.integrador
      if (filters.produtos_base) this.show_base = filters.produtos_base
      this.getCategorias()
      this.getMarcas()
      this.getModelos()
      if (this.$root.Permissions.admin() || this.$root.Permissions.integrator()) {
        this.getDistributors()
      }
      if (this.$root.Permissions.admin() || this.$root.Permissions.distributor()) {
        this.getIntegrators(this.distribuidor)
      }
    },
    getDistributors () {
      Api.get('distribuidores')
        .then(res => {
          if (res.data && res.data.length > 0) {
            let info = []
            res.data.map(item => {
              info.push({
                value: item.uuid_dis_id,
                text: item.dis_nome_fantasia
              })
            })
            this.distribuidores = info
          }
        })
    },
    async getIntegrators (distribuidor = null) {
      this.loadingIntegradores = true
      let url = 'integradores'

      if (distribuidor) {
        url = `distribuidores/${distribuidor}/integradores`
      }
      await Api.get(url)
        .then(res => {
          var arrayInt = []
          res.data.map(int => {
            arrayInt.push({
              'text': int.int_nome,
              'value': int.uuid_int_id
            })
          })

          this.integradores = arrayInt
          this.loadingIntegradores = false
        })
        .catch(err => {
          this.loadingIntegradores = false
          this.$root.SnackControl.open(this, {
            text: err.response.data.status ? err.response.data.status : 'Ops, ocorreu um erro ao buscar os integradores!',
            color: 'error'
          })
          console.log(err)
        })
    },
    async getMarcas () {
      this.loadingMarcas = true
      await Api.get('marcas')
        .then(res => {
          if (res.data && res.data.length > 0) {
            let info = []
            res.data.map(item => {
              info.push({
                text: item.mar_nome,
                value: item.uuid_mar_id
              })
            })
            this.marcas = info
          } else {
            this.marcas = []
          }
          this.loadingMarcas = false
        })
        .catch(err => {
          this.loadingMarcas = false
          this.$root.SnackControl.open(this, {
            text: err.response.data.status ? err.response.data.status : 'Ops, ocorreu um erro ao buscar as marcas!',
            color: 'error'
          })
          console.log(err)
        })
    },
    async getModelos () {
      this.loadingModelos = true
      await Api.get('modelos/geral')
        .then(res => {
          if (res.data && res.data.length > 0) {
            let info = []
            res.data.map(item => {
              info.push({
                text: item.mod_nome,
                value: item.uuid_mod_id
              })
            })
            this.modelos = info
          } else {
            this.modelos = []
          }
          this.loadingModelos = false
        })
        .catch(err => {
          this.loadingModelos = false
          this.$root.SnackControl.open(this, {
            text: err.response.data.status ? err.response.data.status : 'Ops, ocorreu um erro ao buscar as modelos!',
            color: 'error'
          })
          console.log(err)
        })
    },
    async getCategorias () {
      this.loadingCategorias = true
      await Api.get('produtos/categorias')
        .then(res => {
          let info = []
          if (res.data && res.data.length > 0) {
            res.data.map(item => {
              info.push({
                cat_id: item.cat_id,
                text: item.cat_nome,
                value: item.uuid_cat_id,
                color: item.cat_cor
              })
            })
          }
          this.categorias = info
          this.loadingCategorias = false
        })
        .catch(err => {
          this.loadingCategorias = false
          this.$root.SnackControl.open(this, {
            text: err.response.data.status ? err.response.data.status : 'Ops, ocorreu um erro ao buscar as categorias!',
            color: 'error'
          })
          console.log(err)
        })
    },
    retornaCategoria (catId) {
      let categoria = this.categorias.find(cat => cat.cat_id === catId)

      if (!categoria) {
        categoria = {
          cat_id: 0,
          text: 'Categoria removida!',
          value: null,
          color: 'red accent-4'
        }
      }

      return categoria
    },
    async getProdutos () {
      this.carregando = true
      this.total = 0

      const { page, itemsPerPage } = this.options
      let pagina = 1
      let itensPagina = 1
      let endpoint = ''

      if (page) pagina = page
      if (itemsPerPage) itensPagina = itemsPerPage
      if (this.search) endpoint += `&busca=${this.search}`
      if (this.categoria) endpoint += '&categoria=' + this.categoria
      if (this.marca) endpoint += '&marca=' + this.marca
      if (this.modelo) endpoint += `&modelo=${this.modelo}`
      if (this.distribuidor && !this.integrador) endpoint += `&distribuidor=${this.distribuidor}`
      if (this.integrador) endpoint += `&integrador=${this.integrador}`
      if (this.show_base) endpoint += `&produtos_base=${this.show_base}`

      await Api.get(`produtos?page=${pagina}&per_page=${itensPagina}${endpoint}`)
        .then(res => {
          let info = []
          if (res.data && res.data.data.length > 0) {
            res.data.data.map(item => {
              info.push({
                pro_id: item.pro_id,
                fk_int_id_integrador: item.fk_int_id_integrador,
                fk_dis_id_distribuidor: item.fk_dis_id_distribuidor,
                pro_nome: item.pro_nome,
                pro_imagem: item.pro_imagem,
                pro_categoria: item.pro_categoria,
                marca: item.marca ? item.marca.mar_nome : '',
                modelo: item.modelo ? item.modelo.mod_nome : '',
                pro_preco_custo: this.$root.Formatter.floatToMoney(item.pro_preco_custo),
                pro_preco_venda: this.$root.Formatter.floatToMoney(item.pro_preco_venda),
                uuid_pro_id: item.uuid_pro_id
              })
            })
            this.total = res.data.total
          }

          this.dados = info
          this.carregando = false
        })
        .catch(err => {
          this.carregando = false
          this.$root.SnackControl.open(this, {
            text: err.response.data.status ? err.response.data.status : 'Ops, ocorreu um erro ao buscar os produtos!',
            color: 'error'
          })
          console.log(err)
        })
    },
    limparFiltros () {
      this.distribuidor = null
      this.distribuidorAnterior = null
      this.integrador = null
      this.categoria = null
      this.marca = null
      this.modelo = null
      this.show_base = false
      this.limparBusca()
    },
    limparBusca () {
      this.search = null
      this.options.page = 1
      this.applyFilter()
    },
    applyFilter () {
      if (this.distribuidorAnterior && this.distribuidor !== this.distribuidorAnterior) {
        this.integrador = ''
      }

      this.carregando = true

      let query = Object.assign({},
        this.search ? { busca: this.search } : '',
        this.categoria ? { categoria: this.categoria } : '',
        this.marca ? { marca: this.marca } : '',
        this.modelo ? { modelo: this.modelo } : '',
        this.distribuidor ? { distribuidor: this.distribuidor } : '',
        this.integrador ? { integrador: this.integrador } : '',
        this.show_base ? { produtos_base: this.show_base } : ''
      )

      this.$router.replace({name: this.$route.name, query: query}).catch(() => {})

      this.options.page = 1
      this.distribuidorAnterior = this.distribuidor
      this.getIntegrators(this.distribuidor)
      this.getProdutos()
    },
    removerProduto () {
      this.salvando = true
      Api.delete(`produtos/remove/${this.produtoExcluir.uuid_pro_id}`)
        .then(res => {
          this.$root.SnackControl.open(this, {
            text: res.data.msg
          })
          this.dialogExcluir = false
          this.salvando = false
          this.produtoExcluir = null
          this.getProdutos()
        })
        .catch(err => {
          console.log(err)
          this.salvando = false
          this.$root.SnackControl.open(this, {
            text: err.response ? err.response.data.message : 'Erro ao remover produto!',
            color: 'error'
          })
        })
    },
    cancelProdutoDelete () {
      this.dialogExcluir = false
      this.produtoExcluir = null
    },
    openDialogDelete (item) {
      this.produtoExcluir = JSON.parse(JSON.stringify(item))
      this.dialogExcluir = true
    },
    openCloseDialog () {
      this.dialogProduto = !this.dialogProduto
      return this.dialogProduto
    },
    async importaProdutos () {
      this.salvando = true
      const formData = new FormData()
      formData.append(`type`, 'produtos')
      formData.append(`file`, this.produto_importar)

      await Api.post('dados/importar', formData)
        .then(res => {
          this.salvando = false
          this.dialogImport = false

          let info = res.data.info
          if (info['erro-categoria'] === 0 && info['erro-marca'] === 0 && info['erro-modelo'] === 0) {
            this.$root.SnackControl.open(this, {
              text: 'Produtos cadastrados com sucesso!',
              color: 'success'
            })
          } else {
            let text = ''
            if (info['erro-categoria'] > 0) {
              text += `Produtos com categorias inexistentes: ${info['erro-categoria']}<br>`
            }
            if (info['erro-marca'] > 0) {
              text += `Produtos com marcas inexistentes: ${info['erro-marca']}`
            }
            this.$root.SnackControl.open(this, {
              text: `<b>Alguns produtos não puderam ser cadastrados!</b>`,
              lead: text,
              multiline: true,
              time: 50000,
              color: 'warning'
            })
          }
          this.getProdutos()
        })
        .catch(err => {
          this.salvando = false
          this.$root.SnackControl.open(this, {
            text: err.response.data.status ? err.response.data.status : 'Ops, ocorreu um erro ao cadastrar os produtos!',
            color: 'error'
          })
          console.log(err)
        })
    },
    buscaProduto (item) {
      Api.get(`produtos/${item.uuid_pro_id}`)
        .then(res => {
          if (res.data) {
            this.produto = res.data
            this.produto.uuid_mar_id = this.produto.marca ? this.produto.marca.uuid_mar_id : null
            this.produto.uuid_mod_id = this.produto.modelo ? this.produto.modelo.uuid_mod_id : null

            if (!this.produto.modulo) this.produto.modulo = {}
            if (!this.produto.inversor) this.produto.inversor = {}
            if (!this.produto.cabo) this.produto.cabo = {}
            if (!this.produto.stringbox) this.produto.stringbox = {}
            if (!this.produto.estrutura) this.produto.estrutura = {}
            if (!this.produto.transformador) this.produto.transformador = {}

            if (this.produto.produto) this.produto.uuid_pro_id_fk = this.produto.produto.uuid_pro_id

            this.openCloseDialog()
          }
        })
        .catch(err => {
          this.$root.SnackControl.open(this, {
            text: err.response ? err.response.data.message : 'Erro ao buscar produto!',
            color: 'error'
          })
        })
    }
  },
  created () {
    this.loadFunctions()
  }
}
</script>

<style lang="scss" scoped>
@import "@scss/_variables.scss";
@import "@scss/_ui.scss";
>>> .v-text-field--outlined .v-input__append-outer, .v-text-field--outlined .v-input__prepend-outer {
  margin-top: 8px!important;
}
.v-chip {
  width: 125px;
  justify-content: center;
}
.produto_imagem {
  max-height: 100px;
  margin: 5px 0;
  max-width: 200px;
}
</style>



// WEBPACK FOOTER //
// src/pages/produtos/Produtos.vue